export default class Color {
    constructor(manager){

        //manager
        this.manager = manager;

        //dom
        // this.$header = document.getElementById('l-header-bg');
        this.$headerLogo = document.querySelector('#l-header-logo-image');
        this.$headerBlackLogo = document.getElementById('l-header-logo-black');
        this.$headerWhiteLogo = document.getElementById('l-header-logo-white');
        this.$headerText = document.querySelector('#l-header-logo-text');
        this.$headerNavi = document.querySelectorAll('.l-header__navi-item a, .l-header__navi-item .text');
        this.$headerSubNavi = document.querySelectorAll('.l-header__subNavi-item');
        this.$footerSns = document.querySelectorAll('#l-footer__sns');
        this.$footerSound = document.getElementById('l-footer__sound');
        this.$menu = document.getElementById('l-menu__trigger');
        this.$footerLogo = document.querySelector('#l-footer-logo svg');
        this.$footerText = document.getElementById('l-footer-copy');

        //ページごと
        //top
        this.$pager = document.getElementById('p-kv__pager');
        //scene
        this.$control = document.getElementById('p-scene__control');
    }
    set(logoColor,snsColor,footerColor,menuColor,headerOpacity){

        //ページごと
        //top
        this.$pager = document.getElementById('p-kv__pager');
        //scene
        this.$control = document.getElementById('p-scene__control');

        if(logoColor == 'white'){
            logoColor =  '#fff';
        }else{
            logoColor =  '#000';
        }
        if(snsColor == 'white'){
            snsColor =  '#fff';
        }else{
            snsColor =  '#000';
        }
        if(footerColor == 'white'){
            footerColor =  '#fff';
        }else{
            footerColor =  '#000';
        }
        if(menuColor == 'white'){
            menuColor =  '#fff';
        }else{
            menuColor =  '#000';
        }

        //logo ------------------------------------------

        if (logoColor == '#fff') {
            TweenMax.to(this.$headerWhiteLogo, .6 , {
                opacity: 1,
                visibility: 'visible',
                ease: Power2.easeOut,
                onComplete: () => {
                    this.$headerWhiteLogo.style.visibility = 'visible'
                }
            });
            TweenMax.to(this.$headerBlackLogo, .6 , {
                opacity: 0,
                ease: Power2.easeOut,
                onComplete: () => {
                    this.$headerBlackLogo.style.visibility = 'hidden'
                }
            });
        } else {
            TweenMax.to(this.$headerWhiteLogo, .6 , {
                opacity: 0,
                ease: Power2.easeOut,
                onComplete: () => {
                    this.$headerWhiteLogo.style.visibility = 'hidden'
                }
            });
            TweenMax.to(this.$headerBlackLogo, .6 , {
                opacity: 1,
                visibility: 'visible',
                ease: Power2.easeOut,
                onComplete: () => {
                    this.$headerBlackLogo.style.visibility = 'visible'
                }
            });
        }

        TweenMax.to(this.$headerText, .6 , {
            color: logoColor,
            ease: Power2.easeOut,
        });

        //sns ------------------------------------------

        TweenMax.to([this.$footerSound.querySelectorAll('rect')], .6 , {
            fill: snsColor,
            ease: Power2.easeOut,
        });
        TweenMax.to(this.$footerSns, .6 , {
            color: snsColor,
            ease: Power2.easeOut,
        });
        if(snsColor == '#000'){
            this.$footerSns[0].classList.add('is-black');
        }else{
            this.$footerSns[0].classList.remove('is-black');
        }

        //footer ------------------------------------------

        TweenMax.to(this.$footerText, .6 , {
            color: footerColor,
            ease: Power2.easeOut,
        });
        TweenMax.to([this.$footerLogo.querySelectorAll('path'),this.$footerLogo.querySelectorAll('polygon')], .6 , {
            fill: footerColor,
            ease: Power2.easeOut,
        });

        //headerOpacity ------------------------------------------

        // if(headerOpacity === 0){
        //     TweenMax.to(this.$header, .6 ,{
        //         y:'-100%',
        //         ease: Power2.easeOut,
        //         onComplete: () => {
        //             TweenMax.set(this.$header, {
        //                 opacity:0,
        //             });
        //         }
        //     });
        // }else{
        //     TweenMax.set(this.$header, {
        //         opacity:1,
        //     });
        //     TweenMax.to(this.$header, .6 ,{
        //         y:'0%',
        //         ease: Power2.easeOut,
        //     });
        // }

        //header ------------------------------------------

        TweenMax.to([this.$headerNavi, this.$headerSubNavi], 1.2 , {
            color: logoColor,
            fill: logoColor,
            ease: Power2.easeOut,
        });

        //menu ------------------------------------------

        TweenMax.to(this.$menu.querySelectorAll('.l-menu__trigger-text'), .6 , {
            color: menuColor,
            ease: Power2.easeOut,
        });
        TweenMax.to(this.$menu.querySelectorAll('.border'), .6 , {
            backgroundColor: menuColor,
            ease: Power2.easeOut,
        });

        if(this.manager.status.pageID == 'top'){
            if(snsColor == '#000'){
                this.$pager.classList.add('is-black');
            }else{
                this.$pager.classList.remove('is-black');
            }
        }
        if(this.manager.status.pageID == 'scene' || this.manager.status.pageID == "scene-living"){
            if(snsColor == '#000'){
                this.$control.classList.add('is-black');
            }else{
                this.$control.classList.remove('is-black');
            }
        }

    }
}
